export default __webpack_public_path__ + "static/media/cameraFront.c9bef125.png";